/*
 * CyberXL Add-in for Outlook
 */

Office.onReady((info) => {
  if (info.host === Office.HostType.Outlook) {
    // Initialiser l'interface
    initializeUI();


    // Gérer le changement d'item (utile quand le taskpane est épinglé)
    Office.context.mailbox.addHandlerAsync(
      Office.EventType.ItemChanged,
      handleItemChanged
    );
  }
});
/**
 * Appelé quand l'utilisateur change de mail avec le taskpane épinglé
 */
function handleItemChanged(): void {
  console.log("Mail changé, réinitialisation de l'UI");
  
  // Vérifier qu'on est bien sur un item (l'utilisateur peut aussi avoir cliqué hors d'un mail)
  if (!Office.context.mailbox.item) {
    return;
  }
  
  // Réinitialiser les zones d'affichage
  const previewContent = document.getElementById('preview-content');
  if (previewContent) {
    previewContent.innerHTML = '';
  }
  
  // Cacher le loader si jamais il était visible
  hideLoader();
  
  // Si tu as d'autres états à réinitialiser (checkbox, sélections, etc.), fais-le ici
}

/**
 * Initialise l'interface utilisateur
 */
function initializeUI(): void {
  // Masquer les sections
  document.querySelectorAll('.content-section').forEach(section => {
    section.classList.remove('active');
  });

  // Afficher la section de réponse par défaut
  document.getElementById('reply-section')?.classList.add('active');

  // Ajouter les gestionnaires d'événements
  setupEventListeners();
}

/**
 * Configure tous les gestionnaires d'événements
 */
function setupEventListeners(): void {
  // Navigation entre les onglets
  document.querySelectorAll('.nav-tab').forEach((tab, index) => {
    tab.addEventListener('click', () => {
      // Activer l'onglet cliqué
      document.querySelectorAll('.nav-tab').forEach(t => t.classList.remove('active'));
      tab.classList.add('active');

      // Afficher la section correspondante
      document.querySelectorAll('.content-section').forEach(section => {
        section.classList.remove('active');
      });

      if (index === 0) {
        document.getElementById('reply-section')?.classList.add('active');
      } else if (index === 1) {
        document.getElementById('archive-section')?.classList.add('active');
      }
    });
  });

  // Gestionnaire pour le bouton "Répondre Oui"
  document.getElementById('replyYes')?.addEventListener('click', () => {
    createDraftReply(true);
  });

  // Gestionnaire pour le bouton "Répondre Non"
  document.getElementById('replyNo')?.addEventListener('click', () => {
    createDraftReply(false);
  });
}

/**
 * Crée un brouillon de réponse
 * @param isPositive Si la réponse est positive (oui) ou négative (non)
 */
async function createDraftReply(isPositive: boolean): Promise<void> {
  const typeReponse = isPositive? "positive": "négative";

  // Afficher le loader avant de lancer l'appel API
  showLoader();

  //contacter l'api pour récupérer la réponse
  const emailContent = await getEmailContent()
  const reponse = await genererReponseParAPI(emailContent, "https://n8n.cyberxl.net/webhook/d63fb28e-a8ee-40cc-9ebb-521c1554c2d2", typeReponse)

  hideLoader();
  // Afficher l'aperçu
  const previewContent = document.getElementById('preview-content');
  if (previewContent?.innerHTML != null) {
      previewContent.innerHTML = reponse.toString();

      // Créer le brouillon 
      createReplyDraft(reponse.toString());
  }
}

/**
 * Crée un brouillon de réponse à l'email actuel
 * @param bodyContent Contenu du corps de l'email
 */
function createReplyDraft(bodyContent: string): void {
  try {
    // Récupérer l'élément actuellement sélectionné
    const item = Office.context.mailbox.item;

    //TODO: modifier le contenu
    //contenu de la réponse
    var reponse = `
            ${bodyContent}
        `

    //soit on répond à tous, soit on répond uniquement à l'expéditeur selon ce qui a été coché
    var caseRepATous = <HTMLInputElement>document.getElementById("replyAllCheckbox");
    if (caseRepATous.checked) {
      item?.displayReplyAllForm(reponse);
    } else {
      // Créer un brouillon de réponse
      item?.displayReplyForm(reponse);
    }



    // Afficher un message de succès (pourrait être implémenté avec une barre de notification)
    console.log("Brouillon créé avec succès");
  } catch (error) {
    console.error("Erreur lors de la création du brouillon:", error);
  }
}


/**
 * @returns Promesse contenant le contenu du message 
 */
async function getEmailContent(): Promise<string> {
  return new Promise((resolve, reject) => {
    // Vérifier si nous avons accès à l'item Outlook actif
    if (!Office.context.mailbox || !Office.context.mailbox.item) {
      reject(new Error("Impossible d'accéder au message. Vérifiez que vous êtes dans Outlook."));
      return;
    }

    // Récupérer le contenu du message en HTML (pour préserver le formatage)
    Office.context.mailbox.item.body.getAsync(
      Office.CoercionType.Html,
      (result: Office.AsyncResult<string>) => {
        if (result.status === Office.AsyncResultStatus.Succeeded) {
          resolve(result.value);
        } else {
          reject(new Error(`Échec de récupération du contenu: ${result.error ? result.error.message : "Erreur inconnue"}`));
        }
      }
    );
  });
}

/**
 * Envoie le contenu du message à une API externe
 * @param content Contenu du message à envoyer
 * @param apiEndpoint URL de l'API
 * @returns Promesse contenant la réponse de l'API
 */
async function genererReponseParAPI(content: string, apiEndpoint: string, typeReponse: string): Promise<string> {
  try {
    // Créer l'objet de requête avec le contenu du message
    const requestData = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        contenuMail: content,
        timestamp: new Date().toISOString(),
        sujet: Office.context.mailbox.item?.subject,
        expediteur: Office.context.mailbox.item?.from,
        mailUtilisateur: Office.context.mailbox.userProfile.emailAddress,
        typeReponse: typeReponse
      })
    };

    // Envoyer la requête à l'API
    const response = await fetch(apiEndpoint, requestData);

    // Vérifier si la requête a réussi
    if (!response.ok) {
      throw new Error(`Erreur API: ${response.status} ${response.statusText}`);
    }

    // Récupérer et retourner la réponse sous forme de texte
    return await response.text();
  } catch (error) {
    console.error("Erreur lors de l'envoi des données à l'API:", error);
    throw error;
  }
}


/**
 * Affiche le loader et désactive les boutons pour éviter les double-clics
 */
function showLoader(): void {
  const loader = document.getElementById('loader');
  if (loader) loader.style.display = 'flex';
  
  // Désactiver les boutons pendant le chargement
  (document.getElementById('replyYes') as HTMLButtonElement | null)?.setAttribute('disabled', 'true');
  (document.getElementById('replyNo') as HTMLButtonElement | null)?.setAttribute('disabled', 'true');
}

/**
 * Cache le loader et réactive les boutons
 */
function hideLoader(): void {
  const loader = document.getElementById('loader');
  if (loader) loader.style.display = 'none';
  
  // Réactiver les boutons
  (document.getElementById('replyYes') as HTMLButtonElement | null)?.removeAttribute('disabled');
  (document.getElementById('replyNo') as HTMLButtonElement | null)?.removeAttribute('disabled');
}